import { CompositionConfig } from "../types/composition";
import {
	BackgroundVideoProps,
	BackgroundVideoSchema,
	defaultBackgroundVideoProps,
} from "./constants";
import { BackgroundVideo } from "./main";
import { PRESETS, MIN_DURATION_FRAMES } from "../constants";
import { calculateTotalDuration } from "../utils/calculate-duration";

export const BackgroundVideoTemplate: CompositionConfig<BackgroundVideoProps> =
	{
		id: "BackgroundVideo",
		component: BackgroundVideo,
		schema: BackgroundVideoSchema,
		defaultProps: defaultBackgroundVideoProps,
		width: PRESETS.dimensions.landscape.width,
		height: PRESETS.dimensions.landscape.height,
		fps: PRESETS.fps,
		calculateMetadata: async ({ props }) => {
			const fps = PRESETS.fps;
			const totalDurationSeconds = calculateTotalDuration(props.audioTracks);

			return {
				durationInFrames: Math.ceil(
					Math.max(MIN_DURATION_FRAMES, totalDurationSeconds * fps),
				),
				props: {
					...props,
				},
			};
		},
	};
